<template>
  <div class="w-full mt-12 text-2xl text-gray-400  flex flex-col justify-start items-start  ">
    <div id="myFormTabContent">
      <div
        id="tab-properties-content"
        class="  p-4 rounded-lg bg-gray-50 "
        role="tabpanel"
        aria-labelledby="tab-properties-tab"
      >
        <div
          v-if="currentItem != undefined"
          class="mb-6 flex flex-col items-start justify-start w-full"
        >
          <label class="text-left block mb-2 text-sm font-bold text-gray-900 ">
            Texte a afficher </label>
          <div class="flex flex-row justify-start items-center w-96">
            <textarea
              v-model="data"
              type="text"
              class="h-20 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
              required
            />
          </div>
        </div>

        <div
          v-if="currentItem != undefined"
          class="mb-6 flex flex-col items-start justify-start w-full"
        >
          <label class="text-left block mb-2 text-sm font-bold text-gray-900 ">
            Sous titre a afficher </label>
          <div class="flex flex-row justify-start items-center w-96">
            <textarea
              v-model="data"
              type="text"
              class="h-20 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
              required
            />
          </div>
        </div>
        <div
          v-if="currentItem != undefined"
          class="mb-6 flex flex-col items-start justify-start w-full"
        >
          <label class="text-left block mb-2 text-sm font-bold text-gray-900 ">
            image </label>
          <div class="flex flex-row justify-start items-center w-96">
            <textarea
              v-model="image"
              type="text"
              class="h-20 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
              required
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

    export default {
        name: 'DeveloperCellImageText',
        components: {

        },
        props: {
            item: Object
        },

        data() {
            return ({
                lg: "FR",
                currentItem: {},
                image: "",
                data: "",
                subdata: ""
            })
        },
        computed: {

        },
        watch: {
            item: function () {
       

                this.image = this.item.image_url;
                this.data = this.item.data;
                this.subdata = this.item.subdata;

                this.currentItem = this.item;

            }
        },
        mounted() {

            let item = this.item;
            this.image = this.item.image_url;
            this.data = this.item.data;
            this.subdata = this.item.subdata;

            this.currentItem = item;


        },

        methods: {

        }

    }
</script>